<template>
  <div class="container">
    <h4 class="cardD">Entidad federativa en la que se presentarán los originales para cotejo.</h4>

    <div class="row">
      <div class="col-md-6">
        <label>Entidad Federativa</label>
        <select :disabled="false" class="custom-select" v-model="domicilio.entidad">
          <option disabled value="">Seleccione una opción...</option>
          <option v-for="option in optionsEntidades" :key="option.value" :value="option.value">
            {{ option.text }}
          </option>
        </select>
      </div>

      <div class="col-md-6" v-if="hay_municipios">
        <label>Municipio</label>
        <select :disabled="false" class="custom-select" v-model="domicilio.delegacion_municipio">
          <option disabled value="">Seleccione una opción...</option>
          <option v-for="option in optionsMunicipios" :key="option.value" :value="option.value">
            {{ option.text }}
          </option>
        </select>
      </div>
    </div>

    <div class="mt-3">
      <b-row>
        <b-col class="d-flex justify-content-end">
          <b-button class="btn-fill orange-btn" :disabled="disabledComputed" @click="continuarHandler">Continuar</b-button>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import { FuncionesApi } from "@/api";
import { useUIStateStore } from "@/stores";

export default {
  name: "DomicilioEntregaOriginales",

  props: {
    cotejo: { type: Object },
  },

  data() {
    return {
      hay_municipios: false,
      optionsEntidades: [],
      optionsMunicipios: [],
      corredurias: [],
      correduriasLoaded: false,

      noStatesText: "No hay estados disponibles",
      noCitiesText: "No hay ciudades disponibles",
      selectCountry: "",
      selectState: "",
      selectCity: "",
      domicilio: this.cotejo.domicilio_entrega_originales,
    };
  },

  computed: {
    ...mapState(["countries", "states", "cities", "isEmptyStates", "isEmptyCities"]),
    ...mapGetters(["getCountries", "getStatesByCountryId", "getCitiesByStateId"]),

    optionsEntidadesComputed() {
      return [];
    },

    optionsMunicipiosComputed() {
      return [];
    },

    disabledComputed() {
      if (!this.domicilio.entidad) {
        return true;
      }

      // if (this.domicilio.entidad !== "Ciudad de México" && !this.domicilio.delegacion_municipio) {
      //   return true;
      // }

      return false;
    },
  },

  watch: {
    "domicilio.entidad": function (val, oldVal) {
      if (val !== oldVal) {
        this.domicilio.delegacion_municipio = "";
        this.getMunicipios();
      }
    },
  },

  setup() {
    const uiStateStore = useUIStateStore();

    return { uiStateStore };
  },

  async mounted() {
    this.uiStateStore.startLoading();
    await this.fetchCountries();

    if (!this.domicilio.pais) {
      this.domicilio.pais = "México";
    }

    if (!this.domicilio.entidad) this.domicilio.entidad = "";
    if (!this.domicilio.delegacion_municipio) this.domicilio.delegacion_municipio = "";

    this.selectCountry = this.domicilio.pais;

    await this.fetchStatesByCountry();
    await this.getCorredurias();

    this.filterEntidades();
    const entidadExists = this.optionsEntidades.some((opt) => opt.value === this.domicilio.entidad);
    if (!entidadExists) {
      this.domicilio.entidad = "";
    } else {
      this.getMunicipios();
    }
    this.uiStateStore.stopLoading();
  },

  methods: {
    ...mapActions(["fetchCountries", "fetchStates", "fetchCities"]),

    async getCorredurias() {
      try {
        const { value } = await FuncionesApi.getCorreduriasDomicilios({
          entidad: null,
          municipio: null,
        });

        this.corredurias = value.filter((c) => c.corredurias_id !== 17);
        // .map((c) => ({
        //   entidad: c.entidad,
        //   delegacion_municipio: c.delegacion_municipio,
        // }))
      } catch (error) {
        console.log(error);
      } finally {
        this.correduriasLoaded = true;
      }
    },

    filterEntidades() {
      this.optionsEntidades = this.optionsEntidades.filter((e) => this.corredurias.findIndex((c) => c.entidad === e.text) >= 0);
    },

    async fetchStatesByCountry() {
      /**
       * Esta fx se llama solo si ya se tiene un país seleccionado
       */
      const pais = this.selectCountry;
      this.selectState = "";
      this.selectCity = "";
      // change store state cities to empty
      this.$store.commit("setCities", []);
      // Obtengo el id del país
      const paisId = await this.getIdCountry(pais);
      // obtengo los estados del país
      await this.fetchStates(paisId);

      if (this.isEmptyStates) {
        this.selectState = "noStates";
        this.selectCity = "noCities";
      } else {
        this.optionsEntidades = this.states.map((el) => ({ text: el.name, value: el.name }));
      }
    },

    async getIdCountry(countryName) {
      /**
       * Obtiene el id del país seleccionado
       */
      const country = this.countries.find((c) => c.name === countryName);
      return country ? country.id : null;
    },

    getMunicipios() {
      this.hay_municipios = false;
      this.optionsMunicipios = [];

      if (!this.domicilio.entidad) return;

      if (this.domicilio.entidad === "Ciudad de México") {
        this.domicilio.delegacion_municipio = "";
        return;
      }

      // Don't clear/validate municipality until data is loaded
      if (!this.correduriasLoaded) return;

      this.hay_municipios = true;
      this.optionsMunicipios = this.corredurias
        .filter((el) => el.entidad === this.domicilio.entidad)
        .map((el) => ({ text: el.delegacion_municipio, value: el.delegacion_municipio }));

      const exists = this.optionsMunicipios.some((opt) => opt.value === this.domicilio.delegacion_municipio);
      if (!exists) {
        this.domicilio.delegacion_municipio = "";
      }
    },

    continuarHandler() {
      this.$emit("allChecksPassed");
    },
  },
};
</script>
